import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/report",
      name: "report",
      meta: { requiresAuth: true, title: "Rapporter" },
      component: () => import("./main.vue")
    }
  ]
};
